import { render, staticRenderFns } from "./PatientTreatmentDetails.vue?vue&type=template&id=b7a0d76e&"
import script from "./PatientTreatmentDetails.vue?vue&type=script&lang=js&"
export * from "./PatientTreatmentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports